import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-discrete-user-field',
    templateUrl: './editor-eligibility-rule-form-has-discrete-user-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormHasDiscreteUserFieldComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  discreteUserFieldNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.discreteUserFieldNamesWithCategoryNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(discreteUserFieldNamesWithCategoryNames =>
        this.discreteUserFieldNamesWithCategoryNames = discreteUserFieldNamesWithCategoryNames
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getUserFieldName(): string {
    if (this.discreteUserFieldNamesWithCategoryNames === undefined) { return ''; }

    return this.discreteUserFieldNamesWithCategoryNames.find(
      userFieldName => userFieldName.id === this.formGroup.value.userField
    )?.name ?? $localize `Not valid`;
  }

  getUserFieldCategories(): { id: string, name: string }[] {
    if (this.discreteUserFieldNamesWithCategoryNames === undefined) { return []; }

    return this.discreteUserFieldNamesWithCategoryNames.find(
      userFieldName => userFieldName.id === this.formGroup.value.userField
    )?.categoryNames ?? [];
  }
}
